// Dialog pop-up dan toast.
import { $ } from '../core/dom.js';

export const modalTerbuka = () => !!$('#modal-root').innerHTML;
export function closeModal() { $('#modal-root').innerHTML = ''; }

// Dialog konfirmasi kecil. buttons: [{label, cls, on}]
export function modal(html, buttons) {
  const root = $('#modal-root');
  root.innerHTML = `<div class="modal-bg"><div class="card modal" role="dialog" aria-modal="true">${html}<div class="row" style="justify-content:center">${buttons.map((b, i) => `<button class="btn ${b.cls || ''}" data-mi="${i}" type="button">${b.label}</button>`).join('')}</div></div></div>`;
  root.querySelectorAll('[data-mi]').forEach(el => el.onclick = () => { closeModal(); buttons[+el.dataset.mi].on?.(); });
  root.querySelector('[data-mi]').focus();
}

// Dialog lebar dengan isi bebas. Mengembalikan elemen .modal.
export function modalLebar(html, { label = 'Dialog', cls = '' } = {}) {
  const root = $('#modal-root');
  root.innerHTML = `<div class="modal-bg"><div class="card modal modal-wide ${cls}" role="dialog" aria-modal="true" aria-label="${label}">${html}</div></div>`;
  const bg = root.querySelector('.modal-bg');
  bg.addEventListener('click', e => { if (e.target === bg) closeModal(); });
  root.querySelectorAll('[data-close]').forEach(b => b.onclick = closeModal);
  return root.querySelector('.modal');
}

let toastTimer = null;
export function toast(html, { aksi, labelAksi, labelTutup = 'Tutup', onTutup, lama = 6000 } = {}) {
  const el = $('#toast');
  el.innerHTML = `<span>${html}</span>${aksi ? `<button class="btn btn-sm btn-sun" type="button">${labelAksi}</button>` : ''}<button class="btn btn-sm btn-ghost" type="button" aria-label="${labelTutup}">${labelTutup}</button>`;
  el.hidden = false;
  const [b1, b2] = el.querySelectorAll('button');
  if (aksi) b1.onclick = () => { el.hidden = true; aksi(); };
  (aksi ? b2 : b1).onclick = () => { el.hidden = true; onTutup?.(); };
  clearTimeout(toastTimer);
  if (lama) toastTimer = setTimeout(() => { el.hidden = true; }, lama);
}
